const Config = {
  spently: {
    server: 'https://prod-polaris.azurewebsites.net',
    publicApi: 'https://spently-api.azurewebsites.net',
    azureBlobContentFolderUrl:
      'https://productionpolaris.blob.core.windows.net/image-placeholders',
    reco: 'https://spently-recommendation.azurewebsites.net',
    logging: {
      appInsights: {
        key: '863402c1-b180-46ec-b6f1-bac97326b667',
      },
      googleAnalytics: {
        key: 'G-XWSRENL1DX',
        debug: false,
      },
      fullStory: {
        orgId: 'GE9XS',
      },
    },
    intercom: {
      app_id: 'b287081fcfae01b51848211be18c9fddc0a57832',
    },
    googleAnalytics: {
      tracking_id: 'G-EEJM8WLP14',
    },
    clarityCode: 'pgm4fayln8',
  },
  refersion: {
    publicKey: 'pub_618e816549c52def6036',
  },
};

export default Config;
